<template>
  <validation-observer v-slot="{ valid }">
    <validation-helper :interceptor="valid" @isValid="$emit('stepReleased', $event)" />
    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required" id="origem-banco-precos-simulacao">
          <v-select
            v-model="origemDadosBancoPrecos"
            label="Origem dos Dados"
            item-value="value"
            item-text="text"
            no-gutters
            outlined
            :items="origemDadosBancoPrecosList"
            :error-messages="errors"
            @change="clearInputs()"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row class="mx-auto" v-if="origemDadosBancoPrecos === 'CALCULO'">
      <v-col cols="12" class="pl-2 pt-0" id="calculo-banco-precos-simulacao">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            label="Cálculo de Banco de Preços"
            placeholder="Selecione um cálculo"
            outlined
            readonly
            :value="bancoPrecosNome"
            :error-messages="errors"
            @focus.close="dialogSelector = true"
          />
        </validation-provider>
        <dialog-seletor-banco-precos :activated.sync="dialogSelector" @selected="setBancoPrecos($event)" />
      </v-col>
    </v-row>
    <v-row v-else>
      <switch-upload-csv id="csv-simulacao-second-tab" />
    </v-row>
    <validation-provider rules="min_value:1" immediate>
      <input type="hidden" :value="minOneMetodoBancoPrecoSelected" error-messages="errors">
    </validation-provider>
  </validation-observer>
</template>

<script>
export default {
  components: {
    ValidationHelper:         () => import("@/components/general/ValidationHelper.vue"),
    DatePicker:               () => import("@/components/general/DatePicker.vue"),
    DialogSeletorBancoPrecos: () => import("@/components/general/selectors/GeneralBancoPrecosCalculosSelector.vue"),
    SwitchUploadCsv:          () => import("@/components/simulacoesLaudosIncrementais/SwitchUploadCsv.vue"),
  },

  data: () => ({
    dialogSelector: false
  }),
  
  computed: {
    origemDadosBancoPrecosList: {
      get () { return this.$store.state.simulacaoLaudoIncremental.origemDadosBancoPrecosList}
    },
    origemDadosBancoPrecos: {
      get () { return this.$store.state.simulacaoLaudoIncremental.origemDadosBancoPrecos},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'origemDadosBancoPrecos': value})}
    },
    bancoPrecosNome: {
      get () { return this.$store.state.simulacaoLaudoIncremental.bancoPrecos.nome},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'bancoPrecos': {'nome': value}})}
    },
    bancoPrecosId: {
      get () { return this.$store.state.simulacaoLaudoIncremental.bancoPrecos.id},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'bancoPrecos': {'id': value}})}
    },
    infoUploadedFileMaterial: {
      get () { return this.$store.state.simulacaoLaudoIncremental.infoUploadedFileMaterial},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'infoUploadedFileMaterial': value})}
    },
    infoUploadedFileTucagem: {
      get () { return this.$store.state.simulacaoLaudoIncremental.infoUploadedFileTucagem},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'infoUploadedFileTucagem': value})}
    },
    bancoPrecosMateriais: {
      get () { return this.$store.state.simulacaoLaudoIncremental.bancoPrecosMateriais},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'bancoPrecosMateriais': value})}
    },
    bancoPrecosTucagens: {
      get () { return this.$store.state.simulacaoLaudoIncremental.bancoPrecosTucagens},
      set (value) { this.$store.dispatch('setSimulacaoLaudoIncremental', {'bancoPrecosTucagens': value})}
    },
    minOneMetodoBancoPrecoSelected() {
      return this.bancoPrecosId || this.bancoPrecosMateriais || this.bancoPrecosTucagens;
    }
  },

  methods: {
    setBancoPrecos(event) {
      this.bancoPrecosId = event.id;
      this.bancoPrecosNome = `#${event.id} - ${event.nome}`;
      this.dialogSelector = false;
    },

    clearInputs() {
      this.bancoPrecosNome = "";
      this.bancoPrecosId = null;
      this.infoUploadedFileMaterial = {
        id: null,
        delimitador: null,
        involucro: null,
        escape: null,
        mapeamento: {
          "CODIGO_MATERIAL": "",
          "VALOR_UNITARIO": ""
        },
        camposObrigatorios: ["CODIGO_MATERIAL", "VALOR_UNITARIO"]
      };
      this.infoUploadedFileTucagem = {
        id: null,
        delimitador: null,
        involucro: null,
        escape: null,
        mapeamento: {
          "TUC": "",
          "A1": "",
          "A2": "",
          "A3": "",
          "A4": "",
          "A5": "",
          "A6": "",
          "VALOR_UNITARIO": ""
        },
        camposObrigatorios: ["TUC", "A1", "A2", "A3", "A4", "A5", "A6", "VALOR_UNITARIO"]
      },
      this.bancoPrecosMateriais = false;
      this.bancoPrecosTucagens = false;
    }
  }
}
</script>